
export const gridMobile =[
    {
        id: 1,
        image: './images/mobile /image-gallery-milkbottles.jpg',
    },
    {
        id: 2,
        image: './images/mobile /image-gallery-orange.jpg',
    },
    {
        id: 3,
        image: './images/mobile /image-gallery-cone.jpg',
    },
    {
        id: 4,
        image: './images/mobile /image-gallery-sugar-cubes.jpg',
    },

]

export const gridDesktop =[
    {
        id: 1,
        image: './images/desktop/image-gallery-milkbottles.jpg',
    },
    {
        id: 2,
        image: './images/desktop/image-gallery-orange.jpg',
    },
    {
        id: 3,
        image: './images/desktop/image-gallery-cone.jpg',
    },
    {
        id: 4,
        image: './images/desktop/image-gallery-sugarcubes.jpg',
    },

]